var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement } from '@blocksuite/lit';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isValidUrl } from '../../../../../_common/utils/url.js';
let LinkNode = class LinkNode extends ShadowlessElement {
    render() {
        if (!isValidUrl(this.link)) {
            return html `<span class="normal-text">${this.link}</span>`;
        }
        return html `<a
      class="link-node"
      href=${this.link}
      rel="noopener noreferrer"
      target="_blank"
      ><span class="link-node-text">${this.link}</span></a
    >`;
    }
};
LinkNode.styles = css `
    .link-node {
      word-break: break-all;
      color: var(--affine-link-color);
      fill: var(--affine-link-color);
      cursor: pointer;
      font-weight: normal;
      font-style: normal;
      text-decoration: none;
    }
  `;
__decorate([
    property({ attribute: false })
], LinkNode.prototype, "link", void 0);
LinkNode = __decorate([
    customElement('affine-database-link-node')
], LinkNode);
export { LinkNode };
//# sourceMappingURL=link-node.js.map